export default __webpack_public_path__ + "static/media/Frigidaire.e7218da2.svg";